const notificationsReducer = (
  state = {
    loading: false,
    archived: [],
    inbox: []
  },
  action
) => {
  switch (action.type) {
    case "PUT_NOTIFICATION":
      return {
        ...state,
        ...action.payload
      };

    case "PUT_MORE_NOTIFICATION": {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          ...action.payload.notifications
        }
      };
    }

    case "PUT_UNREAD_NOTIFICATION_COUNT":
      return {
        ...state,
        counts: { unread: action.payload }
      };

    default:
      return state;
  }
};
export default notificationsReducer;
